/*
 * Potencium v2 (PL) — «Prezent gratis» from 4 pieces (VigorX v2 engine, 2026-11-03):
 * the HU engine (pooled any-mix rule, exactly one gift, speed path) + the in-form guards
 * Lithuania wrote for a PRICED gift (lt_theme/assets/vx-gift.js, Kenan 2026-10-13/14).
 *
 * The gift is a real product (window.VX_GIFT, from snippets/vx-gift-data.liquid)
 * with a real price: «Prezent gratis 🎁» is 149,99 zł in the catalogue and the
 * discount Function «Rabat ilosciowy — Potencium» (app kenania bundle poland) nets
 * it to 0,01 zł when the cart holds VX_GIFT.min (shop metafield
 * custom.gift_min_quantity = 4) non-gift pieces IN TOTAL, any mix of products —
 * the same pooled count the bundle tiers use. The Function is the final word on
 * price; this file only keeps the gift LINE in step with the cart: exactly one
 * gift when earned, none below the threshold, none when it is left on its own.
 *
 * A wrong line on a priced gift is BILLED (a second unit, or a gift left in a cart
 * below the threshold, costs 149,99 zł), hence the Lithuanian guards:
 *  - cartFromSf: Releasit's own Storefront answer is read instead of a second /cart.js;
 *  - predictEarly: the gift add starts together with a Releasit update that reaches
 *    the threshold (checked against the answer, taken out again if it did not);
 *  - closeNowEmpty: deleting the last product inside the form closes the form at once
 *    and refuses Releasit's own re-add of «its» product (that re-add put 4 × gift at
 *    full price into the cart); the gift left on its own is then taken out;
 *  - reconcile: once nothing is in flight, a doubled gift is trimmed to one and a gift
 *    below the threshold (billed at full price) is taken out.
 *
 * Lessons carried over from Poland, each one cost real orders:
 *  - Every gift add/remove goes through one chain (giftChain), never a boolean
 *    lock: a dropped call left the page painted on a stale cart.
 *  - Releasit's own stepper writes through the Storefront API (cartLinesUpdate),
 *    never /cart/change.js, and the form never re-reads the cart if someone else
 *    changes it. So inside the form we press Releasit's OWN remove button
 *    (rsiGuard) instead of editing the cart behind its back.
 *  - Never touch the cart once the shopper has started typing in the form:
 *    the form posts its own lines with the cart's discount and Shopify clips the
 *    difference -> order total 0.00 (#4235, #4422 in Poland).
 *  - Before the form opens, the cart must read the same twice in a row and the
 *    gift line must be there if earned (settle) — the zero-total orders came
 *    from opening on the first snapshot that merely "grew".
 *
 * No cart attribute: the PL Function has no _vx2 gate (the live PL theme never
 * stamped one), so nothing here writes it.
 *
 * DEBUG  window.vxGift.state()
 */
(function () {
  'use strict';
  if (window.vxGift) return;

  var G = window.VX_GIFT;
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var giftChain = Promise.resolve(false);
  var rsiTouched = false;
  var rsiBusy = false;
  var rsiAgain = null;
  var last = { cart: null, error: null };

  function delay(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  var pending = 0;   // speed 2026-10-14: gift syncs queued on giftChain and not finished yet
  function isFullCart(c) {
    return !!(c && Array.isArray(c.items) && typeof c.token === 'string' && typeof c.total_price === 'number');
  }
  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { last.cart = c; return c; });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: JSONH, body: JSON.stringify(body), credentials: 'same-origin' });
  }
  function isGiftItem(it) { return G && it.variant_id === G.variantId; }

  /* HU 2026-10-15 (Ahmad, order #6962 = 2+2 got no gift): the gift is earned by
     VX_GIFT.min boxes IN TOTAL, any mix of products (was: min of the same product). */
  function qualifies(cart) {
    if (!G) return false;
    var total = 0;
    (cart.items || []).forEach(function (it) {
      if (isGiftItem(it)) return;                       // the gift never counts towards itself
      total += it.quantity;
    });
    return total >= G.min;
  }
  function giftLine(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) if (isGiftItem(items[i])) return items[i];
    return null;
  }

  /* PL: no _vx2 stamp (see the header) — a no-op, so the sync path reads as in HU/LT. */
  function ensureFlag() { return Promise.resolve(false); }

  // speed 2026-10-14: «known» = the cart the bridge read right after its add. It may only
  // confirm that NOTHING has to change; any write (gift add/qty/remove) is decided on a
  // fresh read, so a stale snapshot can never add a second gift.
  function runSync(known) {
    if (!G) return Promise.resolve(false);
    var read = isFullCart(known) ? Promise.resolve(known) : readCart();
    return read.then(function (cart) {
      if (cart === known) {
        var kl = giftLine(cart), kw = qualifies(cart);
        if ((kw && (!kl || kl.quantity !== 1)) || (!kw && kl)) return runSync(undefined);
      }
      return ensureFlag(cart).then(function () {
        var line = giftLine(cart), want = qualifies(cart);
        if (want && (!line || line.quantity !== 1)) {
          return (line
            ? post('/cart/change.js', { id: line.key, quantity: 1 })
            : post('/cart/add.js', { items: [{ id: G.variantId, quantity: 1 }] })
          ).then(function () { return true; });
        }
        if (!want && line) {
          return post('/cart/change.js', { id: line.key, quantity: 0 }).then(function () { return true; });
        }
        return false;
      });
    }).catch(function (e) { last.error = e; return false; });
  }

  function sync(known) {
    // speed 2026-10-14: a snapshot is only trusted when no other gift sync is still queued;
    // the explicit wrapper also stops .then(runSync) passing the previous boolean in as «known»
    if (pending > 0) known = undefined;
    pending++;
    var run = function () { return runSync(known); };
    var done = function () { pending--; };
    giftChain = giftChain.then(run, run);
    giftChain.then(done, done);
    return giftChain;
  }

  /* The cart page renders the gift row without remove/stepper; after the engine
     changes the cart behind the theme, repaint so rows never vanish one by one
     while the real cart stays put (Poland «cart won't empty»). */
  function syncAndRepaint() {
    return sync().then(function (changed) {
      if (changed && window.vxCod && typeof window.vxCod.refresh === 'function') return window.vxCod.refresh();
      return null;
    });
  }

  /* Called by vx-cod-bridge right before the COD form opens: gift line correct,
     then two identical reads in a row (max ~3 s so buying never hangs). */
  function settle(known) {
    if (!G) return Promise.resolve(null);
    var useKnown = isFullCart(known) && pending === 0;
    var sig = function (c) {
      return (c.items || []).map(function (i) { return i.key + 'x' + i.quantity; }).join('|') + '#' + c.total_price;
    };
    var deadline = Date.now() + 3000;
    return sync(useKnown ? known : undefined).then(function (changed) {
      // speed 2026-10-14: when the sync changed nothing, the caller's post-add read is the first
      // of the «two identical reads»; one fresh read that matches it is enough (else: original loop)
      var prev = useKnown && changed === false ? sig(known) : null;
      return (function poll() {
        return readCart().then(function (c) {
          var s = sig(c);
          // 2026-10-14: exactly one gift when earned, none when not (a stray or doubled gift line
          // used to pass this check and bill the second unit at full price)
          var gl = giftLine(c);
          var giftOk = qualifies(c) ? !!(gl && gl.quantity === 1) : !gl;
          if (s === prev && giftOk) return c;
          prev = s;
          if (Date.now() > deadline) return c;
          if (!giftOk) return sync().then(function () { return delay(250); }).then(poll);
          return delay(250).then(poll);
        });
      })();
    }).catch(function (e) { last.error = e; return null; });
  }

  /* ---------- inside the Releasit form ---------- */
  function rsiForm() { return document.querySelector('.rsi-form-main, #rsi_form_wrapper'); }
  function rsiOpen() { var f = rsiForm(); return !!(f && f.offsetHeight); }
  function rsiRows() { return [].slice.call(document.querySelectorAll('.rsi-product-item-wrapper')); }
  function rsiIsGiftRow(w) {
    var nameEl = w.querySelector('.rsi-product-item-name');
    var nm = nameEl ? nameEl.textContent.trim().toLowerCase() : '';
    var img = w.querySelector('img');
    var src = img ? String(img.getAttribute('src') || '') : '';
    return nm.indexOf(String(G.title).toLowerCase()) === 0 || src.indexOf(G.handle) !== -1;
  }
  function watchTyping() {
    ['input', 'change', 'keydown'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var t = e.target;
        if (!t || !t.closest || !/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
        if (t.closest('.rsi-form-main, #rsi_form_wrapper')) rsiTouched = true;
      }, true);
    });
  }

  /* Dropped below the threshold inside the form -> press Releasit's own remove
     on the gift row. Going UP inside the form is left alone on purpose: adding a
     line needs a cart edit behind the form, which is exactly what produced the
     zero-total orders. The PDP pack selector is where 4 is chosen. */
  function rsiClick(row, cls) {
    var b = row.querySelector('button.' + cls);
    if (b) { b.click(); return true; }
    return false;
  }
  /* The form builds its state from ITS OWN mutation response, never from /cart.js. After we
     add the gift behind it, a «+ then −» on a normal row makes Releasit mutate and re-read the
     whole cart (gift included). Checked that «+» really happened before pressing «−», so the
     shopper's quantity is never reduced (Poland 2026-09-22). */
  function rsiNudge(countBefore) {
    if (rsiTouched) return Promise.resolve();
    var row = null, rows = rsiRows();
    for (var i = 0; i < rows.length; i++) if (!rsiIsGiftRow(rows[i])) { row = rows[i]; break; }
    if (!row) return Promise.resolve();
    if (!rsiClick(row, 'rsi-quantity-increase')) return Promise.resolve();
    return delay(1500).then(readCart).then(function (c) {
      if (c.item_count === countBefore + 1) { rsiClick(row, 'rsi-quantity-decrease'); return delay(1200); }
      if (!rsiClick(row, 'rsi-quantity-decrease')) return null;
      return delay(1500).then(readCart).then(function (c2) {
        if (c2.item_count === countBefore - 1) rsiClick(row, 'rsi-quantity-increase');
        return delay(1200);
      });
    });
  }
  function tagGiftRows() {
    if (!G) return;
    rsiRows().forEach(function (w) { w.classList.toggle('vx-rsi-gift', rsiIsGiftRow(w)); });
  }

  function closeEmptyForm() {
    try { if (window._rsiV2 && window._rsiV2.setState) window._rsiV2.setState({ isOpen: false }); } catch (e) {}
    rsiTouched = false;
    if (window.vxCod && typeof window.vxCod.refresh === 'function') window.vxCod.refresh();
  }

  /* Speed (Kenan 2026-10-13: 3→4 in the form took 2.4 s to show the gift): Releasit's own Storefront
     response already carries every line and quantity, so read the cart from it instead of a second
     /cart.js round trip. Falls back to /cart.js if the shape is not recognised. */
  function cartFromSf(json) {
    var found = null;
    (function walk(o, depth) {
      if (found || !o || typeof o !== 'object' || depth > 8) return;
      if (o.lines && (o.lines.edges || o.lines.nodes)) { found = o.lines; return; }
      for (var k in o) walk(o[k], depth + 1);
    })(json, 0);
    if (!found) return null;
    var list = found.edges ? found.edges.map(function (e) { return e && e.node; }) : found.nodes;
    var items = [], count = 0;
    for (var i = 0; i < list.length; i++) {
      var n = list[i]; if (!n || !n.merchandise || !n.merchandise.id) return null;
      var vid = Number(String(n.merchandise.id).split('/').pop());
      items.push({ variant_id: vid, quantity: n.quantity, key: n.id });
      count += n.quantity;
    }
    return { items: items, item_count: count, _fromSf: true };
  }

  /* Speed, step 2: the gift add used to wait for Releasit's own update to come back (≈0.55 s) and
     only then start (≈0.5 s). Releasit's request already says the new quantities, so when they reach
     the threshold the gift add starts at the same moment, in parallel. rsiGuard still checks the
     answer: if Releasit's update did not happen (or went the other way), the gift is taken out again.
     giftPending blocks a second add until a Storefront answer shows the gift (or 5 s pass). */
  var sfLast = null, early = null, giftPending = false, pendingT = 0;
  function setPending(on) {
    giftPending = on; clearTimeout(pendingT);
    if (on) pendingT = setTimeout(function () { giftPending = false; }, 5000);
  }
  function markBuying() {
    // no «added to cart» popup behind the open form for the gift add
    document.documentElement.classList.add('vx-buying');
    clearTimeout(window.__vxBuyingT);
    window.__vxBuyingT = setTimeout(function () { document.documentElement.classList.remove('vx-buying'); }, 8000);
  }
  function predictEarly(body) {
    if (!G || early || giftPending || rsiTouched || !sfLast || giftLine(sfLast) || !rsiOpen()) return;
    var v; try { v = JSON.parse(body).variables; } catch (e) { return; }
    if (!v || !v.lines || !v.lines.length) return;
    var q = {};
    v.lines.forEach(function (l) { if (l && l.id != null && l.quantity != null) q[l.id] = Number(l.quantity); });
    var n = 0, known = 0;
    sfLast.items.forEach(function (it) {
      if (isGiftItem(it)) return;
      if (Object.prototype.hasOwnProperty.call(q, it.key)) { known++; n += q[it.key]; } else n += it.quantity;
    });
    if (!known || n < G.min) return;
    markBuying();
    setPending(true);
    early = post('/cart/add.js', { items: [{ id: G.variantId, quantity: 1 }] })
      .then(function (r) { return !!(r && r.ok); }, function () { return false; });
  }
  /* Kenan 2026-10-14: deleting the last product inside the form must close it at once. Left open,
     Releasit shows a price-less placeholder and then re-adds «its» product × the page quantity on
     its own. So: the moment its CartLinesRemove takes the last non-gift line, close the form; the
     gift left behind is taken out of the cart once the form is shut. */
  var closingEmpty = false;
  function closeNowEmpty() {
    if (closingEmpty) return;
    closingEmpty = true;
    closeEmptyForm();
    early = null; setPending(false);
    // the form closes on Releasit's request; its removal lands a moment later -> wait for it
    // (up to ~4 s) before taking out the gift that is left on its own
    (function settleGift(n) {
      return readCart().then(function (c) {
        var g = giftLine(c);
        if (g && !qualifies(c)) return post('/cart/change.js', { id: g.key, quantity: 0 });
        if (g && n < 16) return delay(250).then(function () { return settleGift(n + 1); });
      });
    })(0).catch(function () {}).then(function () {
      if (window.vxCod && typeof window.vxCod.refresh === 'function') window.vxCod.refresh();
      setTimeout(function () { closingEmpty = false; }, 1500);
    });
  }
  function removesLastProduct(body) {
    if (!sfLast) return false;
    var v; try { v = JSON.parse(body).variables; } catch (e) { return false; }
    var ids = (v && v.lineIds) || [];
    if (!ids.length) return false;
    var left = sfLast.items.filter(function (it) { return !isGiftItem(it) && ids.indexOf(it.key) === -1; });
    return left.length === 0;
  }

  function reloadOrNudge(count) {
    if (window.vxCod && typeof window.vxCod.reloadForm === 'function') {
      return window.vxCod.reloadForm().then(function (ok) { return ok ? null : rsiNudge(count); });
    }
    return rsiNudge(count);
  }

  function rsiGuard(sfJson) {
    if (!G) return;
    if (rsiBusy) { rsiAgain = sfJson || true; return; }
    var form = rsiForm();
    if (!form || !form.offsetHeight) {
      rsiTouched = false;
      if (early) { var e0 = early; early = null; e0.then(function () { return syncAndRepaint(); }); }
      return;
    }
    rsiBusy = true;
    tagGiftRows();
    var fast = sfJson ? cartFromSf(sfJson) : null;
    var pend = early; early = null;
    (pend || Promise.resolve(false)).then(function (addedEarly) {
      return (fast ? Promise.resolve(fast) : readCart()).then(function (cart) { return { cart: cart, addedEarly: addedEarly }; });
    }).then(function (st) {
      var cart = st.cart;
      if (st.addedEarly) {
        // the form already rendered the gift (our add landed before Releasit's update) -> done
        if (cart._fromSf && giftLine(cart)) { setPending(false); return null; }
        if (qualifies(cart)) return reloadOrNudge(cart.item_count + 1).then(function () { tagGiftRows(); });
        // Releasit's update did not reach the threshold after all -> take the gift out again
        setPending(false);
        return post('/cart/change.js', { id: Number(G.variantId), quantity: 0 }).then(function () { return null; });
      }
      return cart;
    }).then(function (cart) {
      if (!cart) return null;
      /* cart emptied from inside the form (last product removed -> the gift goes with it):
         Releasit then shows a price-less placeholder line, so close the form instead. */
      if (!(cart.items || []).length) { closeEmptyForm(); return null; }
      // only the gift left (last product deleted in the form) -> close now, then drop the gift
      if (!(cart.items || []).some(function (it) { return !isGiftItem(it); })) { closeNowEmpty(); return null; }
      /* back up to the threshold inside the form -> gift comes back, but ONLY before the
         shopper starts typing: adding behind a form that is about to submit is exactly what
         produced the zero-total orders (#4235/#4422). After typing, the gift just stays out. */
      if (!giftLine(cart) && qualifies(cart) && !rsiTouched && !giftPending) {
        markBuying();
        setPending(true);
        return post('/cart/add.js', { items: [{ id: G.variantId, quantity: 1 }] })
          // preferred: re-read the cart into the open form (no visible quantity change);
          // fallback to the Poland «+ then −» nudge only if that read is unavailable/fails
          .then(function () { return reloadOrNudge(cart.item_count + 1); })
          .then(function () { tagGiftRows(); });
      }
      if (giftLine(cart) && !qualifies(cart)) {
        var rows = rsiRows();
        for (var i = 0; i < rows.length; i++) {
          if (!rsiIsGiftRow(rows[i])) continue;
          // the remove button is a DIRECT child — without :scope it matches row 1's
          var rm = rows[i].querySelector(':scope > .rsi-product-item-remove');
          if (rm) rm.click();
          break;
        }
        // if the gift was the last line, the cart is now empty -> close the form
        return delay(1600).then(readCart).then(function (c) { if (!(c.items || []).length) closeEmptyForm(); });
      }
    }).catch(function (e) { last.error = e; })
      .then(function () {
        setTimeout(function () {
          rsiBusy = false;
          if (rsiAgain) { var again = rsiAgain; rsiAgain = null; rsiGuard(again === true ? null : again); }
          scheduleReconcile();
        }, 250);
      });
  }

  /* Final check (Kenan 2026-10-14: quick «− +» around 4 left 3 pieces + the gift at €29,99 in the
     form; the same race could leave 5 pieces without it). Each step above reacts to ONE answer of
     Releasit, and answers overtake our gift add. So once the shopper has stopped pressing for a
     moment and nothing is in flight, read the real cart and put it right: gift out below the
     threshold (or a doubled gift trimmed to 1), gift in at/above it (only before typing, as above),
     then re-read the cart into the form. Repeats until the cart is consistent. */
  var recT = 0, recRunning = false, sfInFlight = 0, recRounds = 0;
  function scheduleReconcile(ms) { clearTimeout(recT); recT = setTimeout(reconcile, ms || 650); }
  function reconcile() {
    if (!G || closingEmpty || !rsiOpen()) { recRounds = 0; return; }
    if (rsiBusy || recRunning || sfInFlight > 0) { scheduleReconcile(300); return; }
    if (++recRounds > 4) { recRounds = 0; return; }
    recRunning = true;
    readCart().then(function (c) {
      var real = (c.items || []).some(function (it) { return !isGiftItem(it); });
      if (!real) return false;
      var g = giftLine(c), ok = qualifies(c);
      if (g && (!ok || g.quantity > 1)) {
        setPending(false);
        return post('/cart/change.js', { id: g.key, quantity: ok ? 1 : 0 }).then(function () { return reloadOrNudge(c.item_count); }).then(function () { return true; });
      }
      if (!g && ok && !rsiTouched && !giftPending) {
        markBuying(); setPending(true);
        return post('/cart/add.js', { items: [{ id: G.variantId, quantity: 1 }] }).then(function () { return reloadOrNudge(c.item_count + 1); }).then(function () { return true; });
      }
      return false;
    }).catch(function (e) { last.error = e; return false; }).then(function (changed) {
      recRunning = false;
      tagGiftRows();
      if (changed) scheduleReconcile(700); else recRounds = 0;
    });
  }

  /* ---------- fetch hook: react to every cart write that isn't ours ---------- */
  function hook() {
    var orig = window.fetch;
    var gid = G ? String(G.variantId) : '\u0000';
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var body = init && typeof init.body === 'string' ? init.body : '';
      var isCartWrite = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
      var isOurs = isCartWrite && (body.indexOf(gid) !== -1 || body.indexOf('"_vx2"') !== -1);
      var isSf = url.indexOf('/api/') !== -1 && url.indexOf('graphql.json') !== -1;
      var isSfCart = isSf && body.indexOf('cartLines') !== -1;
      if (isSfCart && body.indexOf('cartLinesUpdate') !== -1) { try { predictEarly(body); } catch (e) {} }
      if (isSfCart && body.indexOf('cartLinesRemove') !== -1 && rsiOpen()) { try { if (removesLastProduct(body)) setTimeout(closeNowEmpty, 0); } catch (e) {} }
      // while the form is being shut after its last product went, refuse Releasit's own «re-add the
      // page product» — that is the request that put 4 × gift back into the cart
      if (closingEmpty && isSf && body.indexOf('cartLinesAdd') !== -1) {
        return Promise.resolve(new Response(JSON.stringify({ data: null, errors: [{ message: 'vx: form closed' }] }), { status: 200, headers: { 'Content-Type': 'application/json' } }));
      }
      var out = orig.apply(this, arguments);
      if (isSfCart) { sfInFlight++; out.then(function () { sfInFlight--; scheduleReconcile(); }, function () { sfInFlight--; scheduleReconcile(); }); }
      if (isCartWrite && !isOurs) out.then(function (r) { if (r && r.ok && !rsiOpen()) setTimeout(syncAndRepaint, 120); return r; }).catch(function () {});
      // every Storefront cart answer (Releasit's updates and its cart reads) keeps sfLast current
      if (isSf && body.indexOf('cart') !== -1) out.then(function (r) {
        try {
          r.clone().json().then(function (j) {
            var c = cartFromSf(j);
            if (c) { sfLast = c; if (giftLine(c)) setPending(false); }
            if (isSfCart) rsiGuard(j);
          }, function () { if (isSfCart) rsiGuard(null); });
        } catch (e) { if (isSfCart) setTimeout(rsiGuard, 50); }
        return r;
      }, function (err) { if (isSfCart) setTimeout(rsiGuard, 50); throw err; }).catch(function () {});
      return out;
    };
  }

  if (G && 'MutationObserver' in window) {
    var tagT = 0;
    new MutationObserver(function () { if (!tagT) tagT = setTimeout(function () { tagT = 0; tagGiftRows(); }, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }

  window.vxGift = {
    sync: sync,
    settle: settle,
    qualifies: qualifies,
    rule: G || null,
    state: function () { return { rule: G || null, rsiTouched: rsiTouched, cart: last.cart, error: last.error && String(last.error) }; }
  };

  if (!G) return;   // no gift product published yet -> engine stays idle
  hook();
  watchTyping();
  setTimeout(syncAndRepaint, 400);
})();
